
angular.module('ui.validationErrorMessage', ['templates']);
